<template>
  <FormFieldWrapper :data="data">
    <VARadioGroup
      :modelValue="modelValue"
      @update:modelValue="handleChange"
      color="dark-blue"
      size="default"
    >
      <VARadio
        v-for="(option, index) in options"
        :key="index"
        :label="option"
      >
        {{ option }}
      </VARadio>
    </VARadioGroup>
  </FormFieldWrapper>
</template>

<script>
import FormFieldWrapper from './FormFieldWrapper.vue';

export default {
  name: 'SingleSelection',
  components: { FormFieldWrapper },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: String,
      default: ''
    }
  },
  computed: {
    options() {
      return this.data?.options || [];
    }
  },
  emits: ['update:modelValue'],
  methods: {
    handleChange(value) {
      this.$emit('update:modelValue', value);
    }
  }
};
</script>

<style scoped>
</style>
